export const showroomDeviceTypes = {
    loading: "LOADING_SHOWROOMDEVICE",
    delete: "DELETE_SHOWROOMDEVICE",
    loadedOne: "LOADED_SHOWROOMDEVICE",
    loadedMultiple: "LOADED_SHOWROOMDEVICES",
    success: "SUCCESS_SHOWROOMDEVICE",
    restore: "RESTORE_SHOWROOMDEVICE",
    hardDelete: "HARDDELETE_SHOWROOMDEVICE",
};
